import { Farm } from 'modules/farm/api/types'
import { atom } from 'recoil'

export const selectedFarmState = atom<Farm | null>({
    key: 'selectedFarmState',
    default: null,
})
